// extracted by mini-css-extract-plugin
export default {"menuBlock":"mE-z","title":"nE-z","nav":"oE-z","flexCell":"pE-z","facetLink":"qE-z"};